import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-cobra-black border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="/logo-full-white.png" alt="Cobra Thai" className="h-12 w-auto mb-4" />
            <p className="text-white/60 text-sm font-manrope leading-relaxed mb-6">
              Pune's premiere MMA & fitness community. Now with a new & bigger facility.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/CobraThaiIndia/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-cobra-red transition-colors"
                data-testid="footer-facebook-link"
                aria-label="Cobra Thai on Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/cobrathai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-cobra-red transition-colors"
                data-testid="footer-instagram-link"
                aria-label="Cobra Thai on Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-anton text-lg mb-4 tracking-wide">QUICK LINKS</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-about"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/membership"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-membership"
                >
                  Membership
                </Link>
              </li>
              <li>
                <Link
                  to="/schedule"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-schedule"
                >
                  Schedule
                </Link>
              </li>
              <li>
                <Link
                  to="/fight-calendar"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-fight-calendar"
                >
                  Fight Calendar
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/60 hover:text-white text-sm font-manrope transition-colors"
                  data-testid="footer-link-terms"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Classes */}
          <div>
            <h3 className="text-white font-anton text-lg mb-4 tracking-wide">CLASSES</h3>
            <ul className="space-y-3">
              <li className="text-white/60 text-sm font-manrope">MMA</li>
              <li className="text-white/60 text-sm font-manrope">Muay Thai / Kickboxing</li>
              <li className="text-white/60 text-sm font-manrope">Brazilian Jiu-Jitsu</li>
              <li className="text-white/60 text-sm font-manrope">Boxing</li>
              <li className="text-white/60 text-sm font-manrope">Wrestling</li>
              <li className="text-white/60 text-sm font-manrope">Cobra Training</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-anton text-lg mb-4 tracking-wide">CONTACT</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-cobra-red mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm font-manrope">
                  Shop no 19/1, Tukaram Nagar, opposite Reliance Mart, Kharadi, Pune, Maharashtra 411014
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-cobra-red mt-0.5 flex-shrink-0" />
                <a href="tel:+919545783636" className="text-white/60 hover:text-white text-sm font-manrope transition-colors">
                  +91 95457 83636
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-cobra-red mt-0.5 flex-shrink-0" />
                <a href="mailto:info@cobrathai.com" className="text-white/60 hover:text-white text-sm font-manrope transition-colors">
                  info@cobrathai.com
                </a>
              </li>
            </ul>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/919545783636?text=Hi!%20I%20want%20to%20know%20more%20about%20Cobra%20Thai%20memberships."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-green-500 hover:bg-green-600 text-white font-bold text-sm px-4 py-2 rounded-sm mt-4 transition-all duration-300"
            >
              <span>Chat on WhatsApp</span>
            </a>
          </div>
        </div>

        {/* Google Maps - with Cobra Thai location marker */}
        <div className="mt-12 rounded-sm overflow-hidden border border-white/10">
          <iframe
            src="https://maps.google.com/maps?q=Cobra%20Thai%20MMA%20Fitness%20Kharadi%20Pune&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Cobra Thai - Shop no 19/1, Tukaram Nagar, Kharadi, Pune"
          />
        </div>

        {/* Get Directions Link */}
        <div className="mt-6 text-center">
          <a
            href="https://www.google.com/maps/dir//Cobra+Thai,+Shop+no+19/1,+Tukaram+Nagar,+Kharadi,+Pune,+Maharashtra+411014"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-cobra-red hover:bg-red-800 text-white font-bold px-6 py-3 rounded-sm transition-all duration-300"
          >
            <MapPin size={20} />
            <span>Get Directions to Cobra Thai</span>
          </a>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 text-center">
          <p className="text-white/40 text-sm font-manrope">
            © {new Date().getFullYear()} Cobra Thai. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;